import { logger } from '../services/logger.ts';
import { supabase } from '../lib/db.ts';
import { MarketCategory } from '../types.ts'; // Assuming MarketCategory is still the union of names

export interface Category {
  id: string;
  name: MarketCategory;
  display_order?: number;
  icon_name?: string;
}

export const fetchMarketCategories = async (): Promise<Category[]> => {
  try {
    const { data, error } = await supabase
      .from('market_categories')
      .select('*')
      .order('display_order', { ascending: true }) // Primary sort by display_order
      .order('name', { ascending: true }); // Secondary sort by name alphabetically

    if (error) {
      logger.error('Error fetching market categories:', error);
      throw error;
    }

    return (data as Category[]) || [];
  } catch (err) {
    logger.error('Exception fetching market categories:', err);
    return []; // Return empty array on error
  }
}; 